import { useState } from "react";

//helpers
import { useHaltPropagation } from "@/components/hooks/utility/useHaltPropagation";
import { getCommentArchivalBannerMessage } from "@/helpers/ActivityFeed";

//interfaces
import { IUseCommentReply } from "@/interfaces/activityFeedNotifications";

//components
import { ActionFeedback} from "thrive-components";



const UseCommentReply = ({isPopOut, activityId, timeStamp, dateStamp, meta, comment, content, appDetails, notificationDetails, onLikeClick, onDeleteCommentClick}: IUseCommentReply) => {
    const [showDeleteFunctionality, setShowDeleteFunctionality] = useState<boolean>(false);
    const showDeletedBanner = content.isArchived || comment.isDeleted
    const deletedBannerMessage = getCommentArchivalBannerMessage(content?.isArchived);
    const deletedCommentClassName = comment?.isDeleted ? "deleted-comment-wrapper" : "";
    const screenClassName = isPopOut ? "" : "full-screen-styling";
    const showFeedbackBanner : boolean = !!notificationDetails;
    const feedbackType = notificationDetails?.isSuccess ? ActionFeedback.SUCCESS : ActionFeedback.ERROR;
    const feedbackMessage = notificationDetails?.message ?? '';
    const truncation = isPopOut ? 95 : 250;
    const hideMenu = content.isArchived;
    const allowCommentFunctionlity = !comment?.isDeleted && meta.commentsEnabled 
    const allowLikeFunctionality = !comment?.isDeleted && meta.likesEnabled;
    const time = isPopOut ? timeStamp : undefined;
    const date = `${timeStamp} · ${dateStamp}`;
    const appImage = appDetails.isMultipleAppOrganisation ? appDetails.iconUrl : "";
    const appName = appDetails.isMultipleAppOrganisation ? appDetails.name : "";
    const likes = meta.likeCount ?? 0
    const handleDeleteClick = allowCommentFunctionlity ? onShowDeleteFunctionalityClick : undefined;
    const handleLikeClick = allowLikeFunctionality ? onLikeClick : undefined;

    function onShowDeleteFunctionalityClick(e?: any) {
        useHaltPropagation(e);
        setShowDeleteFunctionality(true);
    };

    function onHideDeleteFunctionality(e?: any){
        useHaltPropagation(e);
        setShowDeleteFunctionality(false);
    }

    function onDelete(e?: any) {
        useHaltPropagation(e);
        onDeleteCommentClick && onDeleteCommentClick(activityId, appDetails.id, content.id, comment.id);
        setShowDeleteFunctionality(false);
    }

    return { showDeleteFunctionality, showDeletedBanner, deletedBannerMessage, deletedCommentClassName, screenClassName, showFeedbackBanner, feedbackType, feedbackMessage, truncation, hideMenu, time, date, appName, appImage, likes, handleDeleteClick, handleLikeClick, onShowDeleteFunctionalityClick, onHideDeleteFunctionality, onDelete}
};

export default UseCommentReply